import React from "react";
import { Select } from "antd";
import PrimaryButton from "../../button/primarybutton";
import images from "../../../assets";
import OnlineNowUserColumn from "./onlinenowusercolumn";
export default function OnlineNowUserList() {
  return (
    <div className="w-full py-6 bg-white rounded-2xl flex-col justify-center items-center gap-4 inline-flex">
      <div className="self-stretch px-[18.50px] justify-between items-end inline-flex">
        <div className="opacity-70 text-[#222222] text-2xl font-semibold  leading-loose">
          Online Now Users
        </div>
        <div className="w-[145px] bg-white justify-end items-end flex">
          <Select
            showSearch
            style={{ width: 160, height: "40px" }}
            placeholder="Select"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={[
              {
                value: "1",
                label: "Lifetime",
              },
              {
                value: "2",
                label: "Basic",
              },
            ]}
          />
        </div>
      </div>
      <div className="w-full bg-neutral-50 flex-col justify-start items-start flex">
        <div className="w-full px-4 bg-neutral-50 flex-col justify-start items-center flex">
          <div className="w-full bg-basePrimary rounded-tl-2xl rounded-tr-2xl border-b border-basePrimary justify-start items-start flex">
            <div className="w-full h-12 px-4 justify-center items-center flex">
              <div className="text-white text-sm font-semibold  leading-tight">
                Username
              </div>
            </div>
            <div className="w-full h-12 px-4 justify-center items-center flex">
              <div className="text-white text-sm font-semibold  leading-tight">
                Country
              </div>
            </div>
            <div className="w-full h-12 px-4 justify-center items-center flex">
              <div className="text-white text-sm font-semibold  leading-tight">
                Session
              </div>
            </div>
            <div className="w-full h-12 px-4 justify-center items-center flex">
              <div className="text-right text-white text-sm font-semibold  leading-tight">
                Date
              </div>
            </div>
          </div>
          <OnlineNowUserColumn
            style={{ background: "#eae6ed" }}
            profileimg={images.profileSmall}
            name="Rahat"
            flag={images.bdFlag}
            sessiontime="2 hrs 15 mins"
            date="01 July 2024"
          />
          <OnlineNowUserColumn
            style={{ background: "#ffffff" }}
            profileimg={images.profileSmall}
            name="Rahat"
            flag={images.bdFlag}
            sessiontime="2 hrs 15 mins"
            date="01 July 2024"
          />
          <OnlineNowUserColumn
            style={{ background: "#eae6ed" }}
            profileimg={images.profileSmall}
            name="Rahat"
            flag={images.bdFlag}
            sessiontime="2 hrs 15 mins"
            date="01 July 2024"
          />
          <OnlineNowUserColumn
            style={{ background: "#ffffff" }}
            profileimg={images.profileSmall}
            name="Rahat"
            flag={images.bdFlag}
            sessiontime="2 hrs 15 mins"
            date="01 July 2024"
          />
          <OnlineNowUserColumn
            style={{ background: "#eae6ed" }}
            profileimg={images.profileSmall}
            name="Rahat"
            flag={images.bdFlag}
            sessiontime="2 hrs 15 mins"
            date="01 July 2024"
          />
        </div>
      </div>
      <div className="justify-center items-center flex">
        <PrimaryButton
          style={{
            height: "32px",
            width: "188px",
            fontSize: "16px",
            fontWeight: 500,
          }}
          text={"See All"}
          iconalign="left"
          icon={images.messageIcon}
        />
      </div>
    </div>
  );
}
